<template>
  <div v-ps class="dpt-list">
    <header :class="{ selected: currentSelect == company.id }" @click="setCurrent">
      <span v-tip>{{ curUser.companyShort }}</span>
      <span class="setting-dropdown" v-if="!currentCompany.syncDing">
        <dropdown-menu
          :menu-list="[{ title: '新建下级部门', command: 'createSubDepartment' }]"
          placement="bottom-end"
          margin-top="6"
          @click="handleCommand($event, company)"
          class="department-dropdown"
        >
          <el-button type="text" icon="el-icon-setting" @click="closeAllDropdown"></el-button>
        </dropdown-menu>
      </span>
    </header>
    <el-tree
      ref="elTree"
      node-key="id"
      :default-expanded-keys="defaultExpandKeys"
      :data="depTree"
      :props="defaultProps"
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
    >
      <div class="tree-node-text" slot-scope="{ node, data }">
        <span v-tip class="text">{{ node.label }}</span>
        <span class="setting-dropdown" v-if="!currentCompany.syncDing">
          <dropdown-menu
            :menu-list="departmentManageMenu"
            placement="bottom-end"
            margin-top="6"
            @click="handleCommand($event, data)"
            class="department-dropdown"
          >
            <el-button
              type="text"
              icon="el-icon-setting"
              @click.stop="closeAllDropdown"
            ></el-button>
          </dropdown-menu>
        </span>
      </div>
    </el-tree>
    <create-sub-department-dialog
      ref="createSubDepartmentDialog"
      @change="$emit('change')"
    ></create-sub-department-dialog>
    <update-department-dialog
      ref="updateDepartmentDialog"
      @change="$emit('change')"
    ></update-department-dialog>
    <delete-department-dialog
      ref="deleteDepartmentDialog"
      @change="$emit('change')"
    ></delete-department-dialog>
  </div>
</template>

<script>
import { bfs } from "@/utils/algorithm"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import CreateSubDepartmentDialog from "./CreateSubDepartmentDialog"
import UpdateDepartmentDialog from "./UpdateDepartmentDialog"
import DeleteDepartmentDialog from "./DeleteDepartmentDialog"
import { departmentManageMenu } from "./static"

export default {
  name: "dpt-list",
  components: {
    DropdownMenu,
    CreateSubDepartmentDialog,
    UpdateDepartmentDialog,
    DeleteDepartmentDialog
  },
  inject: ["currentCompany"],
  data() {
    return {
      departmentManageMenu,
      company: {},
      depTree: [],
      currentSelect: "",
      defaultProps: {
        children: "children",
        label: "name"
      },
      dropdowns: []
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo || {}
    },
    defaultExpandKeys() {
      let keys = []
      bfs({
        arr: this.depTree,
        childFuc(dpt) {
          // 默认展开两级
          return dpt._deep < 2 ? dpt.children : []
        },
        cbk(dpt) {
          keys.push(dpt.id)
        }
      })
      return keys
    }
  },
  mounted() {
    this.openDialog(this.$route.params?.dialogName)
  },
  methods: {
    init(company) {
      this.company = company
      this.currentSelect = company.id
      this.depTree = company.children
      this.setCurrent()
      this.$nextTick(() => {
        this.dropdowns = Array.from(this.$el.querySelectorAll(".department-dropdown")).map(
          dom => dom.__vue__
        )
      })
    },
    setCurrent() {
      this.$refs.elTree.setCurrentKey(null)
      this.selectDpt(this.company)
    },
    handleNodeClick(data, node, ref) {
      this.closeAllDropdown()
      this.selectDpt(data)
    },
    selectDpt(dpt) {
      this.currentSelect = dpt.id
      this.$emit("select-dpt", dpt)
    },
    openDialog(dialogName) {
      if (dialogName === "add-part") {
        this.handleCommand("createSubDepartment", "")
      }
    },
    handleCommand(cmd, department) {
      switch (cmd) {
        case "createSubDepartment":
          this.$refs.createSubDepartmentDialog.open(department.id)
          break
        case "editDepartment":
          this.$refs.updateDepartmentDialog.open(department)
          break
        case "deleteDepartment":
          this.$refs.deleteDepartmentDialog.open(department.id)
          break
      }
    },
    closeAllDropdown() {
      // dropdowns 是使用dom的__vue__属性取得的,由于未知原因,dropdown-menu和el-popover都有,关闭方法不同
      this.dropdowns.forEach(dropdown => {
        // dropdown-menu 的关闭方法
        dropdown.close && dropdown.close()
        // el-popover 的关闭方法
        dropdown.doClose && dropdown.doClose()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dpt-list {
  height: 100%;
  header {
    height: 42px;
    line-height: 42px;
    font-size: 14px;
    padding-left: 18px;
    padding-right: 15px;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    .setting-dropdown {
      display: none;
    }
    &:hover {
      background-color: #f5f7fa;
    }
    &.selected {
      background-color: #f5f7fa;
      .setting-dropdown {
        display: inherit;
      }
    }
  }
  ::v-deep {
    .is-current {
      & > .el-tree-node__content {
        background-color: #f5f7fa;
        .setting-dropdown {
          display: inherit !important;
        }
      }
    }
    .el-tree-node__content {
      height: 42px;
      font-size: 13px;
      align-items: center;
      .el-tree-node__expand-icon {
        margin-left: 14px;
      }
      .tree-node-text {
        display: flex;
        align-items: center;
        flex: 1 1;
        padding-right: 15px;
        overflow: hidden;
        .text {
          width: 100%;
          line-height: 42px;
        }
        .setting-dropdown {
          display: none;
        }
      }
    }
  }
}
</style>
